export default __webpack_public_path__ + "static/media/안주7.33958f04.jpg";